import { useNavigate, useParams } from "react-router-dom";
import { Result } from 'antd';
import { TextService } from "../../Services/TextService";
import { useEffect, useState } from "react";
import { PublicSiteState } from "./Types/PublicSiteState";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";
import { PublicResultType } from "./Types/PublicResultType";
import { PublicSiteService } from "../../Services/PublicSiteService";

const PublicSiteConfirmEmailChange = () => {
  const [state, setState] = useState(PublicSiteState.Undefined as PublicSiteState);
  const navigation = useNavigate();

  const GetText = TextService.GetText;
  let params = useParams();
  var ranOnce = false;
  useEffect(() => {
    if (!ranOnce) {
      if (params.companyurl != null && params.code != null) {
        try {
          PublicSiteService.GetCompanyPublicSiteByUrl(params.companyurl).then(async () => {
            const result = await PublicSiteService.ConfirmEmailChange({
              companyUrl: params.companyurl,
              code: params.code
            });

            if (result) {
              navigation("/" + getCurrentLanguage() + "/" + params.companyurl + "/success/" + PublicResultType.EmailChangeConfirmed)
            }
            else {
              setState(PublicSiteState.MemberCodeNotFoundOrExpired);
            }
          }).catch(() => {
            setState(PublicSiteState.MemberCodeNotFoundOrExpired);
          })
        }
        catch {
          setState(PublicSiteState.CompanyNotFound);
        }
      }
      ranOnce = true;
    }
  }, []);

  return <div id="start">
    {state === PublicSiteState.CompanyFound || state === PublicSiteState.MemberCodeNotFoundOrExpired ?
      <Result
        status="error"
        title={GetText("PublicSiteEmailChangeConfirm_Failed")}
      /> : ""}
  </div>
};

export default PublicSiteConfirmEmailChange;
